import React from 'react';


class YearMonthComp extends React.Component {
    constructor(props) {
        super(props);
        this.getYearList = this.getYearList.bind(this);
        this.getMonthList = this.getMonthList.bind(this);
        this.state = {
            searchYear: this.getYearList(),
            searchMonth: this.getMonthList(),
        }
    }// end constructor
    getYearList = () => {
        const { thisYear } = this.props
        let arr = [];
        for (let i = 0; i <= 9; i++)  arr.push(thisYear - i);
        return arr;
    }
    getMonthList = () => {
        let arr = [];
        for (let i = 1; i <= 12; i++)  arr.push(i);
        return arr;
    }

    render() {
        const { thisMonth, thisYear,year, month, handleYearSelect, handleMonthSelect } = this.props;

        const { searchYear, searchMonth } = this.state;
        return (
            <>
                {/*51페이지 1번에 해당하는 내용들 년/월 최근 9년까지 input을 설정 할 수 있도록, 9년이 지난 값은 선택하지못하게 구현*/}
                <select className='form-select d-inline w-auto me-1' name="year" id="" onChange={handleYearSelect}>
                    {searchYear.map((yearcount, i) => (
                        <option key={i} value={yearcount} > {yearcount} 년</option>
                    ))}
                </select>
                <select className='form-select d-inline w-auto me-1' name="month" id="" onChange={handleMonthSelect} value={month}>
                    {searchMonth.map((monthcount, i) => (
                        <option key={monthcount}
                                value={monthcount}
                                disabled={(year === thisYear - 9 && thisMonth > monthcount)}
                        >{monthcount} 월</option>
                    ))}
                </select>
            </>
        )
    } // end render
}// end class

export default YearMonthComp;
